import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { getJsonGenerateFormNoiTru } from '../../../services/BenhAnServices';

type Props = {
	url?: string;
	code?: string;
};

const useFormIO = ({ url, code }: Props) => {
	const [formJSON, setFormJSON] = useState<any>();
	const [generalForm, setGeneralForm] = useState<any>();
	
	useEffect(() => {
		if (code) {
			getFormIO();
		}
	}, [code]);

	const getFormIO = async () => {
		try {
			if (code) {
				const resForm = await getJsonGenerateFormNoiTru(code as string);
				const formJSON = JSON.parse(resForm?.data?.data);
				setFormJSON(formJSON);
				setGeneralForm(formJSON);
				return;
			};

			const form = await fetch(url as string);
			const response = await form.json();
			setFormJSON(response);
		} catch (error) {
			console.error(error);
			toast.error("Có lỗi xảy ra khi lấy dữ liệu form");
		}
	};

	return { formJSON, generalForm };
};

export default useFormIO;
